import React, { useEffect, useState } from "react";
import { CommonAxiosGet } from "../CommonUtils/CommonAxios";
import { config } from "../CommonUtils/CommonURLS";
import { viewImage } from "../CommonUtils/viewImage";
import { useLocation } from "react-router-dom";
import { generateDeficienciesPdf } from "../PdfGenerate";
import { FaChartBar, FaRegChartBar } from "react-icons/fa";
const safeArray = (val) => (Array.isArray(val) ? val : []);
const dedup = (arr, key = "sno") =>
  Array?.from(new Map(arr.map((item, i) => [item[key] ?? i, item])).values());
const fmt = (v) => (v !== null && v !== undefined && v !== "" ? String(v) : null);

const courseValueMaps = {
  reg_self: { R: "Regular", S: "Self-Financed", SS: "Self Support" },
};

const INST_FIELDS = [
  { key: "ub_name", label: "University Name" },
  { key: "inst_name", label: "Name of Institution" },
  { key: "coll_code", label: "Institute Code" },
  { key: "aishe_code", label: "AISHE Code" },
  { key: "place_town", label: "Place / Town" },
  { key: "inst_address", label: "Complete Postal Address" },
  { key: "dist_name", label: "District" },
  { key: "mandal_name", label: "Mandal" },
  { key: "pincode", label: "PIN Code" },
  { key: "std_code", label: "STD Code" },
  { key: "telephone_no", label: "Telephone No" },
  { key: "mobile_no", label: "Mobile No" },
  { key: "email", label: "Email ID" },
  { key: "year_of_establishment", label: "Year of Establishment" },
  { key: "coll_nature_name", label: "Institute Management Type" },
  // { key: "ub_name", label: "University / Region" },
  { key: "principle_name", label: "Principal Name" },
  { key: "principle_mobile", label: "Principal Mobile" },
  { key: "principle_email", label: "Principal Email" },
  { key: "total_intake_student", label: "Total Approved Intake " },
  { key: "no_of_students_admitted", label: "No of students admitted (S)" },

  { key: "total_faculty_count", label: "Total Faculty Count (F)" },
  { key: "compound_ration", label: "Computed SFR (S : F)" },

]
const INST_Society = [

  { key: "society_name", label: "Society / Trust Name" },
  { key: "society_reg_no", label: "Society Reg. No. & Date" },
  { key: "secretry_name", label: "Secretary / Correspondent Name" },
  { key: "secretry_mobile", label: "Secretary Mobile No" },
  { key: "secretry_email", label: "Secretary e-mail ID" },
  { key: "minor_status", label: "Minority Status" },

];

const INST_NACC = [
  { key: "naac_accrediated", label: "Whether Accredited by NAAC" },
  { key: "latest_naac_cgpa", label: "Current NAAC CGPA" },
  { key: "naac_status", label: "Current NACC Grade" },
  { key: "latest_naac_upto_date", label: "Current NAAC From Date" },
  { key: "latest_naac_from_date", label: "Current NAAC Upto Date" },
  { key: "latest_naac_certi", label: "Current NAAC Certificate" },
  { key: "has_previous_naac", label: "Previous NACC Cycles's Available" },
];

const COURSE_COLS = [
  { key: "course_group_desc", label: "Academic Program Type" },
  { key: "course_cat_name", label: "Course / Program" },
  { key: "course_name", label: "Branch / Specialization" },
  // { key: "medium_name", label: "Medium" },
  { key: "reg_self", label: "Regular / Self-Financed" },
  { key: "course_noc_type", label: "Permanent / Temporary" },
  { key: "intake", label: "Intake" },
  { key: "section_no", label: "No of Sections" }
];

const STAFF_COLS = [
  { key: "staff_name", label: "Name of Faculty" },
  { key: "designation_name", label: "Staff Designation" },
  // { key: "staff_qualification", label: "Staff Qualification" },
  // { key: "emp_type_name", label: "Regular / Contract" },
  { key: "course_name", label: "Staff Qualification" },

  { key: "staff_mobile", label: "Contact No." },
  { key: "staff_aadhar", label: "Aadhaar No" },
  { key: "doj", label: "Date of Joining" },

  { key: "yr_of_joining", label: "Year of Appt." },
  { key: "designation_name", label: "Designation" },
  // { key: "remarks", label: "Remarks" },
];

const ENHANCE_COLS = [
  { key: "course_id", label: "Course ID" },
  { key: "nature", label: "Nature" },
  { key: "sanction_intake", label: "Sanction Intake" },
  { key: "change", label: "Change" },
  { key: "effective_intake", label: "Effective Intake" },
  { key: "aicte_ref", label: "AICTE Ref" },
  // { key: "ac_year", label: "AC Year" },
];

const MERGE_COLS = [
  { key: "course_id", label: "Course ID" },
  { key: "nature", label: "Nature" },
  { key: "existing_intake", label: "Existing Intake" },
  { key: "revised_intake", label: "Revised Intake" },
  { key: "proposed_name", label: "Proposed Name" },
  { key: "justification", label: "Justification" },
];



const BUILDING_COLS = [
  // { key: "sl_no", label: "Sl. No" },
  { key: "build_block_name", label: "Block Name" },
  { key: "no_of_floors", label: "No. of Floors" },
  { key: "site_area", label: "Site Area" },
  { key: "campus_type", label: "Campus Type" },
  // { key: "ffca_status", label: "FFCA Status" },
  // { key: "ffca_deficiencies", label: "FFCA Deficiencies" },
  // { key: "ac_year", label: "AC Year" },
  // { key: "soc_copy_upload", label: "Upload Copy of Resolution" },
  { key: "building_img", label: " Building Image" },

  // { key: "build_block_slno", label: "Action / Status" },
];

const BUILD_AREA_FIELDS = [
  { key: "total_area", label: "Total Area (Sq. Ft)" },
  { key: "instructional_area", label: "Instructional Area" },
  { key: "admin_area", label: "Administrative Area" },
  { key: "amenities_area", label: "Amenities Area" },
  { key: "access_circul_area", label: "Access & Circulation Area" },
];

const INSTRUCTIONAL_COLS = [
  { key: "particular_name", label: "Particular" },
  { key: "build_block_name", label: "Building Block" },
  { key: "floor_no_build_block", label: "Level/Floor No" },
  { key: "no_of_rooms", label: "Room No" },
  { key: "length", label: "Length(Sq.Ft)" },
  { key: "breadth", label: "Breadth(Sq.Ft)" },
  { key: "height", label: "Height(Sq.Ft)" },
  { key: "total_area", label: "Total Area (Sq.Ft)" },
  // { key: "utilization", label: "Utilization" },
  { key: "building_img", label: "Building Image" },

];

const LAB_COLS = [
  { key: "lab_details", label: "Lab Details" },
  { key: "lab_type", label: "Lab Type" },
  { key: "build_block_name", label: "Building Block" },
  { key: "block_name", label: "Block Name" },
  { key: "floor_no_build_block", label: "Floor No" },
  { key: "no_of_rooms", label: "No. of Rooms" },
  { key: "no_of_floors", label: "No. of Floors" },
  { key: "length", label: "Length (Sq. Fts)" },
  { key: "breadth", label: "Breadth(Sq. Fts)" },
  { key: "height", label: "Height (Sq. Fts)" },
  { key: "area", label: "Area (Sq. Fts)" },
  { key: "building_img", label: "Lab Image" },


  // { key: "utilization", label: "Utilization" },
  // { key: "ffca_status", label: "FFCA Status" },
  // { key: "ffca_area", label: "FFCA Area" },
  // { key: "ffca_deficiency", label: "FFCA Deficiency" },
];

const FACILITIES_FIELDS = [
  { key: "total_approved_intake", label: "Total Approved Intake" },
  { key: "total_students_admitted", label: "Total Students Admitted" },
  { key: "no_boys_admitted", label: "No. of Boys Admitted" },
  { key: "no_girls_admitted", label: "No. of Girls Admitted" },
  { key: "total_builtup_area", label: "Total Built-up Area" },
  { key: "builtup_area_20percent", label: "Built-up Area (20%)" },
  { key: "no_toilets", label: "No. of Toilets" },
  { key: "no_toilets_provided", label: "No. of Toilets Provided" },
  { key: "no_boys_toilets", label: "Boys Toilets" },
  { key: "no_girls_toilets", label: "Girls Toilets" },
  { key: "seperate_female_toilets", label: "Separate Female Toilets" },
  { key: "girls_commonroom", label: "Girls Common Room" },
  { key: "parking_area", label: "Parking Area (Sq. Fts)" },
  { key: "parking_provided", label: "Parking Provided" },
  { key: "playground_area", label: "Playground Area (Sq. Ft)" },
  { key: "playground_avail", label: "Playground Available" },
  { key: "playground_distance", label: "Playground Distance" },
  { key: "playground_tieup", label: "Playground Tie-up" },
  { key: "transport_facility_avail", label: "Transport Facility" },
  { key: "biometric_adopted_for_teaching_non", label: "Biometric (Teaching/Non-Teaching)" },
  { key: "biometric_adopted__for_students_ug_pg", label: "Biometric (Students UG/PG)" },
  { key: "parking_area_document", label: "Parking Area Document" },

];
const ShiftingApplicationSer = [
  { key: "shift_type", label: "Shift Type" },
  { key: "new_dist", label: "District" },
  { key: "mandal_name", label: "Mandal" },
  { key: "secretariat_name", label: "Secretariat " },
  { key: "constituency_name", label: "Constituency" },
  { key: "village_name", label: "Village" },
  { key: "new_pincode", label: "Pin Code" },
  { key: "address_ofnew_location", label: "New  Location Address" },
  { key: "distance_from_existing", label: "Distance from the existing College Location to the Proposed College Location (in KMs)" },
  { key: "is_permanent_rcc", label: "Whether the new building is permanent and independent with RCC roof" },
  { key: "is_distance_500m", label: "Whether it is located at least 500 mtrs far away from Cinema halls, wine shops, public function halls etc" },
  { key: "justification", label: "Rationale / Justification " },

  { key: "thirty_years_lease", label: "Whether the College Possess 30 Years of Lease for New Building" },
  { key: "lease_from_date", label: "Validity of the Lease Period of New Building From Date" },
  { key: "lease_to_date", label: "Validity of the Lease Period of New Building To Date" },
];


const LIBRARY_FIELDS = [
  { key: "library_carpet_area", label: "Library Carpet Area (Sq. Fts)" },
  { key: "reading_room_capacity", label: "Reading Room Capacity" },
  { key: "separate_room", label: "Separate Room" },
  { key: "books_journals", label: "Books & Journals" },
  { key: "computer_systems", label: "Computer Systems" },
  { key: "no_comupters", label: "No. of Computers" },
  { key: "no_terminals_internet_connection", label: "Internet Terminals" },
  { key: "internet_bandwidth", label: "Internet Bandwidth (Mbps)" },
  { key: "internet_mbps", label: "Internet Speed (Mbps)" },
  { key: "high_speed", label: "High Speed" },
  { key: "ip_address", label: "IP Address" },
  { key: "nptel", label: "NPTEL" },
  { key: "digital", label: "Digital Library" },
  { key: "access_online_course", label: "Access Online Courses" },
  { key: "repgraphic_phtgraphic", label: "Reprographic / Photographic" },
  { key: "automation_software", label: "Automation Software" },
  { key: "supporting_staff", label: "Supporting Staff" },
  { key: "area_examination_wing", label: "Examination Wing Area" },
  { key: "examination_area", label: "Examination Area" },
];

const UG_PG_COLS = [
  { key: "course_cat_name", label: "Course Category" },
  { key: "count", label: "Count" },
  { key: "sum", label: "Total Intake" },
];

const SOFTWARE_COLS = [

  { key: "software_name", label: "Software Name" },
  { key: "no_of_licenses", label: "No. of Licenses" },

];

const JOURNAL_COLS = [
  { key: "details", label: "Course Details" },
  { key: "course_cat_name", label: "Category" },
  { key: "course_name", label: "Course" },
  { key: "no_of_titles", label: "No. of Titles" },
  { key: "no_of_volumes", label: "No. of Volumes" },
  { key: "no_of_national", label: "National Journals" },
  { key: "no_of_international", label: "International Journals" },
  { key: "no_of_ejournals", label: "E-Journals" },
];

const CORPUS_COLS = [
  { key: "course_name", label: "Course Name" },
  { key: "coll_type", label: "Type" },
  { key: "fdr_type", label: "FDR / Bank Guarantee" },
  { key: "fdr_bank_number", label: "FDR/Bank Number" },
  { key: "amount", label: "Amount" },
  { key: "corpus_date", label: "Corpus Date" },
  { key: "period_from", label: "Period From" },
  { key: "period_to", label: "Period To" },
  { key: "date_maturity", label: "Maturity Date" },
  { key: "date_renewal", label: "Renewal Date" },
  { key: "bank_address", label: "Bank" },
  { key: "ifsc", label: "IFSC Code" },
  { key: "upload_fdr_bank_gaurantee", label: "Upload FDR / Bank Guarantee" },
  { key: "mro_document", label: "MRO Document	" }

];
const CORPUS_INSTALL_COLS = [
  { key: "installment_no", label: "Installment No" },
  { key: "amount", label: "Amount" },
  { key: "fdr_bank_guarantee", label: "FDR / Bank Guarantee No" },
  { key: "bank_address", label: "Bank" },
  { key: "ifsc", label: "IFSC Code" },
  { key: "from_date", label: "From Date" },
  { key: "to_date", label: "To Date" },
  { key: "date_of_fdr", label: "Date of FDR" },
  { key: "date_of_maturity", label: "Date of Maturity" },
  { key: "date_of_renewal", label: "Date of Renewal" },
  { key: "rural_area", label: "Rural Area" },
];
const CorpusBasicCols = [
  { key: "programsanction", label: "New Programmes Sanctioned" },
  { key: "rural_area", label: "Rural / Tribal Area" },
  { key: "plan_approved", label: "Plan Approved" },
  { key: "leaseagreement", label: "Lease Agreement" },
  { key: "mro_document", label: "MRO Document" },
  { key: "ac_year", label: "Academic Year" },
];
const NAMECHANGE_COLS = [
  { key: "current_name", label: "Current Name" },
  { key: "proposed_newname", label: "Proposed New Name" },
  { key: "reason_change", label: "Reason" },
  { key: "english_news_paper", label: "English News Paper" },
  { key: "english_paper_publisheddate", label: "Eng. Published Date" },
  { key: "telugu_news_paper1", label: "Telugu Paper 1" },
  { key: "telugu_paper1_publisheddate", label: "Telugu P1 Date" },
  { key: "telugu_news_paper2", label: "Telugu Paper 2" },
  { key: "telugu_paper2_publisheddate", label: "Telugu P2 Date" },
  // { key: "ac_year", label: "AC Year" },
];


const EopApplicationCols = [
  { key: "Own", label: "Whether the society has own land as per norms" },
  { key: "extendland", label: "Extent of land owned by the Society" },
  { key: "mandal_name", label: "Name of the Mandal in which the land is registered" },
  { key: "distance", label: "Distance of the land from the college building (in km)" },

  // Leased Building Accommodation Details
  { key: "year_of_establishment", label: "Year of Establishment of the college" },
  { key: "years_completed_leased", label: "Total no. of years completed in leased building from the establishment" },
  // User selected values from application form
  { key: "plan_approved", label: "Whether the plan of the building accommodation is approved by competent authority" },
  { key: "leaseagreement", label: "Do you have 30 years of Leased Agreement for the Building" },
  { key: "build_own_lease", label: "Type of College Accommodation" },

];
const CLOSURE_COLS = [
  { key: "inst_name", label: "Institution Name" },
  { key: "nature_of_closure", label: "Nature of Closure" },
  { key: "proposed_closure_year", label: "Proposed Closure Year" },
  { key: "inst1_code", label: "Inst 1 Code" },
  { key: "inst1_name", label: "Inst 1 Name" },
  { key: "inst1_students", label: "Inst 1 Students" },
  { key: "inst1_supply", label: "Inst 1 Supply" },
  { key: "inst2_code", label: "Inst 2 Code" },
  { key: "inst2_name", label: "Inst 2 Name" },
  { key: "inst2_students", label: "Inst 2 Students" },
  { key: "inst2_supply", label: "Inst 2 Supply" },
  { key: "justification", label: "Justification" },
];

const TYPECONV_COLS = [
  { key: "typeradio", label: "Type" },
  { key: "justification", label: "Justification" },
  // { key: "ac_year", label: "AC Year" },
];
const NEWCOURSE_COLS = [
  { key: "course_group_desc", label: "Course Group Description" },
  { key: "course_name", label: "Course Name" },
  { key: "course_cat_name", label: "Course Category" },
  { key: "course_noc_type", label: "NOC Type" },
  { key: "reg_self", label: "Reg / Self" },
  { key: "proposed_intake", label: "Proposed Intake" },
  { key: "aicte_ref", label: "AICTE Ref" },
  { key: "medium_name", label: "Medium" },
  { key: "area_fee", label: "Area Fee" },


];

const MERGECLOSE_COLS = [
  { key: "course_group_desc_old", label: "Old Group Description" },
  { key: "course_cat_name_old", label: "Old Course Category" },
  { key: "course_name_old", label: "Old Course Name" },
  { key: "existing_intake", label: "Existing Intake" },
  { key: "course_group_desc", label: "New Group Description" },
  { key: "course_cat_name", label: "New Course Category" },
  { key: "course_name", label: "New Course Name" },
  { key: "revised_intake", label: "Revised Intake" },
];

const CONVERSION_COLS = [
  { key: "course_group_desc_old", label: "Old Group Description" },
  { key: "course_cat_name_old", label: "Old Category Name" },
  { key: "course_name_old", label: "Old Course Name" },
  { key: "existing_intake", label: "Existing Intake" },
  { key: "course_group_desc", label: "New Group Description" },
  { key: "course_cat_name", label: "New Category Name" },
  { key: "course_name", label: "New Course Name" },
  { key: "revised_intake", label: "Revised Intake" },
];

const ADMISSION_COLS = [
  // Basic Information
  { key: "sno", label: "S.No" },
  { key: "coll_code", label: "College Code" },
  { key: "ac_year", label: "Academic Year" },
  { key: "stream_name", label: "Stream Name" },
  { key: "single_major_name", label: "Single Major Name" },

  // Year 1 (First Year)
  { key: "sanctioned_intake_year1", label: "Year 1 - Sanctioned Intake" },
  { key: "admitted_year1", label: "Year 1 - Admitted" },
  { key: "admission_percent_year1", label: "Year 1 - Admission %" },

  // Year 2 (Second Year)
  { key: "sanctioned_intake_year2", label: "Year 2 - Sanctioned Intake" },
  { key: "admitted_year2", label: "Year 2 - Admitted" },
  { key: "admission_percent_year2", label: "Year 2 - Admission %" },

  // Year 3 (Third Year)
  { key: "sanctioned_intake_year3", label: "Year 3 - Sanctioned Intake" },
  { key: "admitted_year3", label: "Year 3 - Admitted" },
  { key: "admission_percent_year3", label: "Year 3 - Admission %" },

  // Semester 5 & 6
  { key: "sem5_students", label: "Semester 5 - Students" },
  { key: "sem5_percent", label: "Semester 5 - %" },
  { key: "sem6_students", label: "Semester 6 - Students" },
  { key: "sem6_percent", label: "Semester 6 - %" },

  // Metadata
  { key: "insert_time", label: "Insert Time" },
  { key: "insert_ip", label: "Insert IP" },
  { key: "insert_by", label: "Insert By" },
];
const RESULT_COLS = [
  { key: "sno", label: "S.No" },
  { key: "ug_programme_name", label: "Programme" },
  { key: "stream_name", label: "Stream" },
  { key: "ac_year", label: "Academic Year" },

  // Batch 2020-23
  { key: "appeared_year20_23", label: "2020-23 Batch - Appeared" },
  { key: "passed_year20_23", label: "2020-23 Batch - Passed" },
  { key: "percent_year20_23", label: "2020-23 Batch - %" },

  // Batch 2021-24
  { key: "appeared_year21_24", label: "2021-24 Batch - Appeared" },
  { key: "passed_year21_24", label: "2021-24 Batch - Passed" },
  { key: "percent_year21_24", label: "2021-24 Batch - %" },

  // Batch 2022-25
  { key: "appeared_year22_25", label: "2022-25 Batch - Appeared" },
  { key: "passed_year22_25", label: "2022-25 Batch - Passed" },
  { key: "percent_year22_25", label: "2022-25 Batch - %" },
];

const SHIFTING_COLS = [
  { key: "shift_type", label: "Shift Type" },
  { key: "new_dist", label: " District" },
  { key: "new_mandal", label: " Mandal" },
  { key: "village_name", label: " Village" },

  { key: "new_pincode", label: "New Pincode" },
  { key: "address_ofnew_location", label: "New Location Address" },
  { key: "distance_from_existing", label: "Distance from Existing (Km)" },
  { key: "is_permanent_rcc", label: "Permanent RCC" },
  { key: "is_distance_500m", label: "Distance > 500m" },
  { key: "justification", label: "Justification" },
  // { key: "ac_year", label: "AC Year" },
];

const SOC_LAND_BASIC_FIELDS = [
  { key: "society", label: "Whether the land is available in the name of society" },
  { key: "build_own_lease", label: "Type of College Accommodation" },
  { key: "no_years", label: "No. of Years the college is being run in Leased Accommodation" },
  { key: "lease_deed", label: "Lease Deed Document" },
  { key: "college_strength", label: "Strength of the college" },

  { key: "survey_no", label: "Survey No" },
  { key: "plot_no", label: "Plot No" },

  { key: "dist_name", label: "Distance from the present location of the college to the proposed shifting location (in KM)" },
  { key: "mandal_name", label: "Mandal" },
  { key: "village_name", label: "Village" },

  { key: "total_land", label: "Total Land (Sq. Yds)" },
  { key: "distance", label: "Distance (Km)" },
  { key: "Total Extent of Land(In Acres)", label: "" },
  { key: "same_primises", label: "Is any other College running in the same Premises" },

];



const OTHER_COLLEGE_COLS = [
  { key: "inst_name", label: "Institute Name" },
];

// Building Lease Details Columns (from lease array)
const BUILDING_LEASE_COLS = [
  { key: "document_number", label: "Document No./Year" },
  { key: "date_of_registration", label: "Date of Registration" },
  { key: "survey_number", label: "Survey No." },
  { key: "dist_name", label: "District" },
  { key: "mandal", label: "Mandal" },
  { key: "sro_div_name", label: "SRO Division" },
  { key: "sro_location", label: "Registrar Office" },
  { key: "name_of_leasee", label: "Name of the Lease" },
  { key: "leased_from", label: "Leased From" },
  { key: "leased_upto", label: "Leased Upto" },
  { key: "address", label: "Address of the Property Leased" },
  { key: "extent_of_land", label: "Leased Extent of Land (in Acres)" },
];

// Registered Land Details Columns (from own array)
const REGISTERED_LAND_COLS = [
  { key: "reg_no", label: "Document No./Year" },
  { key: "reg_date", label: "Date of Registration" },
  { key: "survey_no", label: "Survey No." },
  { key: "area_acres", label: "Extent of Land (in Acres)" },
  { key: "dist_name", label: "District" },
  { key: "mandal", label: "Mandal" },
  { key: "sro_div_name", label: "SRO Division" },
  { key: "sro_location", label: "Registrar Office" },
  { key: "mortgaged", label: "Is Land Mortgaged" },
  { key: "mortgage_registered_doc_no", label: "Mortgage registered Document No" },
];

// Location of Land for Shifting (from land array, when build_own_lease = false)
const LOCATION_SHIFTING_FIELDS = [
  { key: "plot_no", label: "Plot No" },
  { key: "survey_no", label: "Survey No" },
  { key: "distance", label: "Distance from present location (in KM)" },
  { key: "dist_name", label: "District Name" },
  { key: "mandal_name", label: "Mandal Name" },
  { key: "village_name", label: "Village Name" },
  { key: "total_land", label: "Total Extent of Land (In Acres)" },
];


const LAND_ALL_FIELDS = [
  // ================= BASIC EXTENT =================
  { key: "total_land", label: "Extent of Land in which college is being run (In Acres)" },
  { key: "land_alloc", label: "Extent of Land Allocated by Society (In Acres)" },
  { key: "land_reg_type", label: "Type of Land Registration" },
  { key: "land_type", label: "Land Type" },

  // ================= SOCIETY DETAILS =================
  { key: "soc_land_alloc_date", label: "Allotment Date" },
  { key: "soc_land_alloc_valid_upto", label: "Valid Upto Date" },
  { key: "soc_copy_upload", label: "Upload Copy of Resolution" },

  // ================= KHASRA / MRO =================
  { key: "khasra_issued_by", label: "Khasra Issued By" },
  { key: "khasra_issued_date", label: "Khasra Issued Date" },
  { key: "khasra_doc_no", label: "Khasra Document No" },
  { key: "khasra_plan_file", label: "Upload Khasra Certificate" },

  // ================= LAND CONVERSION =================
  { key: "land_conv_details", label: "Land Conversion Available" },
  { key: "land_conversion_issued_by", label: "Conversion Issued By" },
  { key: "land_conversion_issued_date", label: "Conversion Issued Date" },
  { key: "land_conversion_issued_purpose", label: "Purpose" },
  { key: "land_conversion_file", label: "Upload Conversion Certificate" },

  // ================= LAND USAGE =================
  { key: "land_usage_details", label: "Land Usage Details Available" },
  { key: "land_usage_issued_by", label: "Usage Issued By" },
  { key: "land_usage_issued_date", label: "Usage Issued Date" },
  { key: "land_usage_purpose", label: "Purpose" },
  { key: "land_usage_certificate", label: "Upload Land Usage Certificate" },
];


/* ═══════════════════════════════════════════════
   PRINT STYLES — injected once on mount
═══════════════════════════════════════════════ */
const PRINT_STYLES = `
@media print {
  @page {
    margin: 10mm 8mm;
    size: A4 portrait;
  }

  body * { visibility: hidden; }
  .pvp-root, .pvp-root * { visibility: visible; }
  .pvp-root { position: absolute; top: 0; left: 0; width: 100%; }

  /* ── Hide screen-only elements ── */
  .pvp-print-btn,
  .pvp-header { display: none !important; }

  /* ── Kill ALL overflow / scroll wrappers ── */
  .pvp-table-wrap {
    overflow: visible !important;
    overflow-x: visible !important;
    width: 100% !important;
  }

  /* ── Make every table shrink-to-fit the page width ── */
  .pvp-table {
    width: 100% !important;
    max-width: 100% !important;
    table-layout: auto !important;
    border-collapse: collapse !important;
    font-size: 7.5pt !important;
    word-break: break-word !important;
    overflow: visible !important;
  }

  /* ── Compact cells so wide tables fit ── */
  .pvp-table th,
  .pvp-table td {
    padding: 3px 4px !important;
    font-size: 7.5pt !important;
    word-break: break-word !important;
    white-space: normal !important;
    overflow-wrap: break-word !important;
    max-width: 120px !important;
  }

  /* ── Key-value grid: 2 columns on print ── */
  .pvp-kv-grid {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 2px 8px !important;
    font-size: 8pt !important;
  }

  /* ── Section spacing ── */
  .pvp-section,
  .pvp-subsection {
    page-break-inside: avoid;
    margin-bottom: 8px !important;
  }

  /* ── Avoid breaking table rows across pages ── */
  .pvp-table tr {
    page-break-inside: avoid;
  }

  /* ── Section headers ── */
  .pvp-sec-hdr {
    page-break-after: avoid;
    font-size: 9pt !important;
  }
}
`;

/* ═══════════════════════════════════════════════
   SUB-COMPONENTS
═══════════════════════════════════════════════ */
function PrintStyles() {
  useEffect(() => {
    const existing = document.getElementById("__pvp_print_styles");
    if (existing) return;
    const style = document.createElement("style");
    style.id = "__pvp_print_styles";
    style.innerHTML = PRINT_STYLES;
    document.head.appendChild(style);
    return () => {
      document.getElementById("__pvp_print_styles")?.remove();
    };
  }, []);
  return null;
}

function SecHdr({ icon, title, color, bg, count }) {
  return (
    <div className="pvp-sec-hdr">
      <div className="pvp-sec-icon" style={{ background: bg, color }}>
        {icon}
      </div>
      <span className="pvp-sec-title">{title}</span>
      {count !== undefined && (
        <span className="pvp-sec-badge" style={{ background: bg, color }}>
          {count} {count === 1 ? "record" : "records"}
        </span>
      )}
    </div>
  );
}
const FILE_FIELDS = [
  "soc_copy_upload",
  "khasra_plan_file",
  "land_conversion_file",
  "land_usage_certificate",
  "latest_naac_certi",
  "lease_deed",
  "mro_document",
  "building_img",
  "parking_area_document",
  "building_img"
]
function renderValue({ key, value, valueMaps }) {
  const isFileField = FILE_FIELDS.includes(key);

  const rawVal = fmt(value);
  const normalized = String(rawVal).toLowerCase();

  const finalVal =
    normalized === "true"
      ? "Yes"
      : normalized === "false"
        ? "No"
        : rawVal ?? "—";

  // 📁 File case
  if (isFileField && value) {
    return (
      <button
        className="pvp-doc-view-btn"
        onClick={() => viewImage(value)}
      >
        <i className="fa fa-eye" /> View
      </button>
    );
  }

  // 🗺️ Value mapping
  if (valueMaps?.[key]) {
    return valueMaps[key][value] || "—";
  }

  return finalVal;
}

// function FieldGrid({ data, fields }) {
//   const visible = fields.filter((f) => {
//     const val = fmt(data[f.key]) ?? (f.fallbackKey ? fmt(data[f.fallbackKey]) : null);
//     return val !== null;
//   });
//   if (!visible.length) return <div className="pvp-empty">No data available.</div>;
//   return (
//     <div className="pvp-kv-grid">
//       {visible.map(({ key, fallbackKey, label }) => {
//         const isFileField = FILE_FIELDS?.includes(key);

//         const rawVal = fmt(data[key]) ?? (fallbackKey ? fmt(data[fallbackKey]) : null);
//         const normalized = String(rawVal).toLowerCase();

//         const val =
//           normalized === "true"
//             ? "Yes"
//             : normalized === "false"
//               ? "No"
//               : rawVal ?? "—";
//         return (
//           <div className="pvp-kv-item" key={key}>
//             <span className="pvp-kv-key">{label}</span>
//             <span className="pvp-kv-val">
//               {/* {key === "lease_deed" && data[key] ? (

//                 <button
//                   className="pvp-doc-view-btn"
//                   onClick={() => viewImage(data[key])}
//                 >
//                   View
//                 </button>
//               ) : (
//                 val
//               )} */}

//               {isFileField && data[key] ? (
//                 <button
//                   className="pvp-doc-view-btn"
//                   onClick={() => viewImage(data[key])}
//                 >
//                   <i className="fa fa-eye" /> View
//                 </button>
//               ) : (
//                 val
//               )}
//             </span>
//           </div>
//         );
//       })}
//     </div>
//   );
// }


// function FieldGrid({ data, fields, valueMaps = {} }) {
//   const visible = fields.filter((f) => {
//     const val = fmt(data[f.key]) ??
//       (f.fallbackKey ? fmt(data[f.fallbackKey]) : null);
//     return val !== null;
//   });

//   if (!visible.length) {
//     return <div className="pvp-empty">No data available.</div>;
//   }

//   return (
//     <div className="pvp-kv-grid">
//       {visible.map(({ key, fallbackKey, label }) => {
//         const value =
//           data[key] ??
//           (fallbackKey ? data[fallbackKey] : null);

//         return (
//           <div className="pvp-kv-item" key={key}>
//             <span className="pvp-kv-key">{label}</span>
//             <span className="pvp-kv-val">
//               {renderValue({ key, value, valueMaps })}
//             </span>
//           </div>
//         );
//       })}
//     </div>
//   );
// }

function FieldGrid({ data, fields, valueMaps = {} }) {

  // Support both object and array
  const row = Array.isArray(data) ? data[0] || {} : data || {};

  const visible = fields.filter((f) => {
    const val =
      fmt(row[f.key]) ??
      (f.fallbackKey ? fmt(row[f.fallbackKey]) : null);

    return val !== null;
  });

  if (!visible.length) {
    return <div className="pvp-empty">No data available.</div>;
  }

  return (
    <div className="pvp-kv-grid">
      {visible.map(({ key, fallbackKey, label }) => {
        const value =
          row[key] ??
          (fallbackKey ? row[fallbackKey] : null);

        return (
          <div className="pvp-kv-item" key={key}>
            <span className="pvp-kv-key">{label}</span>

            <span className="pvp-kv-val">
              {renderValue({ key, value, valueMaps })}
            </span>
          </div>
        );
      })}
    </div>
  );
}
function ArrayTable({ rows = [], columns = [], valueMaps = {} }) {
  if (!rows.length) {
    return <div className="pvp-empty">No records found.</div>;
  }

  return (
    <div className="pvp-table-wrap">
      <table className="pvp-table">
        <thead>
          <tr>
            <th>S.No</th>
            {columns.map((c) => (
              <th key={c.key}>{c.label}</th>
            ))}
          </tr>
        </thead>



        <tbody>
          {Array.isArray(rows) &&
            rows.map((row, i) => (
              <tr key={i}>
                <td>{i + 1}</td>

                {Array.isArray(columns) &&
                  columns.map((c) => (
                    <td key={c.key}>
                      {renderValue({
                        key: c.key,
                        value: row?.[c.key],
                        valueMaps,
                      })}
                    </td>
                  ))}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}



function DocumentsGrid({ docs }) {
  if (!docs || !docs.length) return null;
  return (
    <div className="pvp-table-wrap">
      <table className="pvp-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Document Name</th>
            <th>NOC Type</th>
            {/* <th>AC Year</th> */}
            <th style={{ width: 100 }}>View Document</th>
          </tr>
        </thead>
        <tbody>
          {docs.map((doc, i) => (
            <tr key={doc.sno ?? i}>
              <td>{i + 1}</td>
              <td>{doc.doc_name || `Document ${doc.doc_id}`}</td>
              <td>{doc.noc_type || "—"}</td>
              {/* <td>{doc.ac_year || "—"}</td> */}
              <td>
                <button
                  className="pvp-doc-view-btn"
                  onClick={() => viewImage(doc.doc_path)}
                >
                  <i className="fa fa-eye" /> View
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

/* ═══════════════════════════════════════════════
   MAIN EXPORT
═══════════════════════════════════════════════ */
export default function PreviewandPrint({ service, collCode, nocType }) {
  console.log("PreviewandPrint props:", { service, collCode, nocType });
  const userid = sessionStorage.getItem("user_id");

  const location = useLocation();
  const inspectionCollegeCode = collCode;
  const inspNocType = nocType;
  const InspStatusclgcode = location.state?.clgcode?.coll_code;
  const InspStatusNocType = location.state?.clgcode?.noc_type;
  const ClgNocType = location.state?.nocType;

  const Clg = sessionStorage?.getItem("LOGIN");
  const isNocUser = userid?.startsWith("noc");

  const [nocdata, setNocdata] = useState(null);
  const Login_type = sessionStorage?.getItem("Login_Type");
  const userId = sessionStorage.getItem("user_id");
  const userName = sessionStorage.getItem("user_name")

  const DegreeAdminCollcode = location?.state?.clgcode?.coll_code;
  const serviceKeyMap = {
    "Merger of Institutions": "merge_ofinstructions",
    "Conversion of the Institution": "type_converstions",
    "Closure of Institution": "closure_of_institutions",
    "Trust / Society Name Change": "society_name_change",
    "Programme / Intake Changes": "intake_changes",
    "Shifting of the Institution": "shifting",
    "Change of Institution Name": "change_of_inst_name",
    "Extension of Permission (EoP)": "eop",
    "Management Change": "management",
    // "New Programme / Section Changes": "new_program",
    "New Program": "new_program",
    "Conversion of Program": "conversion_program",
    "Additional Section": "additional_sec"
  };

  const fullServiceName =
    Object.keys(serviceKeyMap).find(
      key => serviceKeyMap[key] === InspStatusNocType
    ) ?? "";

  console.log("fullServiceName,", fullServiceName);

  const [deficienciesList, setDeficienciesList] = useState([]);
  const handleDownloadPDF = () => {
    let url = `${config.url.FAC_URL}getEOPDeficiencyDetails/${userId}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res && res.data.status === true) {
          const deficiencyData = res.data.data || [];
          setDeficienciesList(res.data.data);
          if (deficiencyData.length > 0) {
            const rowData = {
              inst_name: userName || apiValues.society_name || apiValues.inst_name || "College",
              coll_code: userId,
              noc_type: "Eop",
              deficiencies: deficiencyData.map((item) => ({
                remarks: item.deficiency_description || item.remarks || item.deficiency || ""
              }))
            };

            generateDeficienciesPdf(rowData);
          } else {
            Swal.fire({
              icon: 'info',
              title: 'No Deficiencies',
              text: 'No deficiencies found to download',
              confirmButtonColor: '#3085d6'
            });
          }
        } else {
          Swal.fire({
            icon: 'info',
            title: 'No Data',
            text: 'No deficiencies data available',
            confirmButtonColor: '#3085d6'
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching deficiencies:", error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch deficiencies. Please try again.',
          confirmButtonColor: '#d33'
        });
      });
  };
  const handleClick = () => {
    window.open("/PaymentReceipt", "_blank");
  };
  const isEightDigitNumber = /^\d{8,}$/.test(userId);
  const final_collcode = Login_type === "degree" ? collCode :
    userId === "jd_admin" || userId === "section_admin"
      ? DegreeAdminCollcode
      : Login_type === "scrutiny"
        ? collCode
        : userId?.startsWith("noc")
          ? userId.split("_")[1]
          : isEightDigitNumber
            ? inspectionCollegeCode
            : userId;

  const finalService = Clg === "degree" ? nocType :
    userId === "jd_admin"
      ? fullServiceName : userId === "section_admin" ? InspStatusNocType
        : Login_type === "scrutiny"
          ? inspNocType
          : service;

  console.log("ClgNocType>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>:", finalService);

  useEffect(() => {
    // setLoading(true);
    CommonAxiosGet(
      `${config.url.FAC_URL}getPreView?collCode=${final_collcode}&nocType=${finalService}`
    )
      .then((res) => {
        setNocdata(res?.data?.scode === "01" ? res.data : null);
        // setLoading(false);
      })
    // .catch(() => setLoading(false));
  }, [finalService]);


  const inst = nocdata?.instDetails?.[0] || {};
  const courses = dedup(safeArray(nocdata?.courseIntake));

  // Format land data for display
  const landData = nocdata?.land?.[0] || {};

  const formattedBuildOwnLease = landData.build_own_lease === "true" ? "Own" : landData.build_own_lease === "false" ? "Leased" : landData.build_own_lease;

  // Format same_primises for display
  const formattedSamePrimises = landData.same_primises === "true" ? "Yes" : landData.same_primises === "false" ? "No" : landData.same_primises;

  // Format society for display
  const formattedSociety = landData.society === "Yes" ? "Yes" : landData.society;
  const check_lease_own = formattedBuildOwnLease

  const formattedBasicData = {
    survey_no: landData.survey_no,
    plot_no: landData.plot_no,
    village_name: landData.village_name,
    mandal_name: landData.mandal_name,
    dist_name: landData.dist_name,
    total_land: landData.total_land,
    distance: landData.distance,

    society: formattedSociety,
    // build_own_lease: formattedBuildOwnLease,
    build_own_lease:
      landData.build_own_lease === true
        ? "Own"
        : landData.build_own_lease === false
          ? "Lease"
          : "—",
    no_years: landData.no_years,
    college_strength: landData.college_strength,
    same_primises: formattedSamePrimises,

    // ✅ FIX HERE
    lease_deed: landData.lease_deed || '',
  };


  const formattedLandAllData = {
    total_land: landData.total_land,
    land_alloc: landData.land_alloc,
    land_reg_type: landData.land_reg_type === "1" ? "Registered Gift deed" : "-",
    land_type: landData.land_type === "1" ? "Contiguous" : "-",

    soc_land_alloc_date: landData.soc_land_alloc_date,
    soc_land_alloc_valid_upto: landData.soc_land_alloc_valid_upto,
    soc_copy_upload: landData.soc_copy_upload || null,

    khasra_issued_by: landData.khasra_issued_by,
    khasra_issued_date: landData.khasra_issued_date,
    khasra_doc_no: landData.khasra_doc_no,
    khasra_plan_file: landData.khasra_plan_file || null,

    land_conv_details: landData.land_conv_details ? "Yes" : "No",
    land_conversion_issued_by: landData.land_conversion_issued_by,
    land_conversion_issued_date: landData.land_conversion_issued_date,
    land_conversion_issued_purpose: landData.land_conversion_issued_purpose,
    land_conversion_file: landData.land_conversion_file || null,

    land_usage_details: landData.land_usage_details ? "Yes" : "No",
    land_usage_issued_by: landData.land_usage_issued_by,
    land_usage_issued_date: landData.land_usage_issued_date,
    land_usage_purpose: landData.land_usage_purpose,
    land_usage_certificate: landData.land_usage_certificate || null,
  };


  // Format land details for shifting location
  const formattedShiftingData = {
    plot_no: landData.plot_no,
    survey_no: landData.survey_no,
    distance: landData.distance,
    dist_name: landData.dist_name,
    mandal_name: landData.mandal_name,
    village_name: landData.village_name,
    total_land: landData.total_land,
  };

  // Format own land details
  const formattedOwnLandData = {
    land_coll_run: landData.total_land,
    land_alloc: landData.land_alloc,
    reg_type_name: landData.land_reg_type === "1" ? "Registered Gift deed" : landData.land_reg_type === "2" ? "Registered Sale Deed" : landData.land_reg_type === "3" ? "Government Lease" : landData.land_reg_type === "4" ? "Others" : landData.land_reg_type,
    land_type_name: landData.land_type === "1" ? "Contiguous" : landData.land_type === "2" ? "Bits (or) Pieces" : landData.land_type,
  };

  // Format allotment data
  const formattedAllotmentData = {
    alloc_date: landData.soc_land_alloc_date,
    alloc_upto: landData.soc_land_alloc_valid_upto,
  };

  // Format Khasra data
  const formattedKhasraData = {
    khasra_issued_by: landData.khasra_issued_by,
    khasra_issued_date: landData.khasra_issued_date,
    khasra_doc_no: landData.khasra_doc_no,
  };
  // Format land conversion data
  const formattedLandConversionData = {
    land_conversion_issued_by: landData.land_conversion_issued_by,
    land_conversion_issued_date: landData.land_conversion_issued_date,
    land_conversion_issued_purpose: landData.land_conversion_issued_purpose,
  };

  const formattedLandUsageData = {
    land_usage_issued_by: landData.land_usage_issued_by,
    land_usage_issued_date: landData.land_usage_issued_date,
    land_usage_purpose: landData.land_usage_purpose,
  };

  const formattedOtherColleges =
    Array.isArray(nocdata?.otherclgdtls) &&
      nocdata.otherclgdtls !== "No data found"
      ? nocdata.otherclgdtls.map((item) => ({
        inst_name: item.inst_name || "-",
      }))
      : [];

  const staff = dedup(safeArray(nocdata?.staff));
  const documents = nocdata?.document_status && Array.isArray(nocdata?.document) ? nocdata.document : [];
  const enhance = dedup(safeArray(nocdata?.enhanceReduction));
  const mergeClose = dedup(safeArray(nocdata?.mergeclose));
  const land = safeArray(nocdata?.land);
  const own = land.filter(item =>
    item.build_own_lease === true || item.build_own_lease === "true"
  );
  const lease = land.filter(item =>
    item.build_own_lease === false || item.build_own_lease === "false"
  );
  const buildingBlocks = safeArray(nocdata?.buildingblock);
  const buildArea = safeArray(nocdata?.buildArea);
  const instructional = safeArray(nocdata?.Instructional);
  const labs = safeArray(nocdata?.lab);
  const facilities = safeArray(nocdata?.collegefacilities);
  const library = safeArray(nocdata?.libraryfacilities);
  const software = safeArray(nocdata?.software);
  const journal = safeArray(nocdata?.journal);
  const corpusUGPG = safeArray(nocdata?.corpusfundUGPGAfter);

  const corpusBasic = safeArray(nocdata?.eopCorpusFund);
  // const corpusData = corpusBasic?.length ? corpusBasic[0] : [];
  const corpusData = corpusBasic?.length
    ? corpusBasic[0]
    : { data: [] };
  const corpusInstall = safeArray(nocdata?.corpusFundInstall);

  const ugCourses = safeArray(nocdata?.ugCourses);
  const pgCourses = nocdata?.pgCourses_status ? safeArray(nocdata?.pgCourses) : [];
  const nameChange = safeArray(nocdata?.nameChange);
  const closure = safeArray(nocdata?.closure);
  const societyName = safeArray(nocdata?.societyName);
  const chairPerson = safeArray(nocdata?.chairPerson);
  const boardOfGoverners = safeArray(nocdata?.boardOfGoverners);
  const typeconv = safeArray(nocdata?.typeconv);
  const newCourse = safeArray(nocdata?.newCourse);
  const mergeclose = safeArray(nocdata?.mergeclose);
  const filteredData = mergeclose.filter(
    item => ["NameChange", "Merger", "Conversion"].includes(item.nature)
  );

  const admission = safeArray(nocdata?.admission);
  const result = safeArray(nocdata?.result);

  // const shifting = safeArray(nocdata?.shifting);
  // const Shiftingser = nocdata?.shiftingApplicationForm[0] || {};

  // const shiftingApplication = safeArray(nocdata?.shiftingApplication);
  // const EopApplication = safeArray(nocdata?.eopApplicationForm);
  const Shiftingser = nocdata?.shiftingApplicationForm || [];
  const EopApplication = nocdata?.eopApplicationForm?.[0] || [];

  const eopShiftingData = safeArray(nocdata?.eopshifting?.[0] || {});
  const prepareApplicationFormData = () => {
    // Get data from various sources
    const shiftingAppData = nocdata?.shiftingApplication?.[0] || {};
    const eopShiftingData = nocdata?.eopshifting?.[0] || {};
    const institutionData = nocdata?.instDetails?.[0] || {};
    const landData = nocdata?.land?.[0] || {};

    // Calculate years completed
    const yearsCompleted = institutionData?.year_of_establishment
      ? new Date().getFullYear() - Number(institutionData.year_of_establishment)
      : '--';

    // Determine society own land value from eopshifting data
    let societyOwnLand = '--';
    if (eopShiftingData?.build_own_lease) {
      societyOwnLand = eopShiftingData.build_own_lease === "Own" ? "Own" :
        eopShiftingData.build_own_lease === "Leased" ? "Leased" :
          eopShiftingData.build_own_lease === "lease" ? "Leased" :
            eopShiftingData.build_own_lease === "true" ? "Own" :
              eopShiftingData.build_own_lease === "false" ? "Leased" :
                eopShiftingData.build_own_lease;
    } else if (landData?.build_own_lease) {
      societyOwnLand = landData.build_own_lease === true || landData.build_own_lease === "true" ? "Own" : "Leased";
    }

    return {
      // From shiftingApplication or eopshifting (user selections)
      plan_approved: shiftingAppData?.plan_approved || eopShiftingData?.plan_approved || '--',
      leaseagreement: shiftingAppData?.leaseagreement || eopShiftingData?.leaseagreement || '--',

      // From eopshifting (land details)
      society_own_land: societyOwnLand,
      extent_land_owned: eopShiftingData?.extendland || landData?.total_land || landData?.extendland || '--',
      mandal_name: eopShiftingData?.mandal_name || landData?.mandal_name || '--',
      distance_from_college: eopShiftingData?.distance || landData?.distance || '--',

      // From institution details
      year_of_establishment: institutionData?.year_of_establishment || '--',
      years_completed_leased: yearsCompleted,
      build_own_lease: eopShiftingData?.build_own_lease === "lease" ? "Leased" :
        eopShiftingData?.build_own_lease === "Own" ? "Own" : '--',
    };
  };
  const applicationFormData = prepareApplicationFormData();
  const formattedLand = land.map(item => ({
    ...item,
    build_own_lease: item.build_own_lease === true || item.build_own_lease === "true" ? "Yes" : "No",
    same_primises: item.same_primises === true || item.same_primises === "true" ? "Yes" : "No",
  }));

  const formattedLabs = labs.map(item => ({
    ...item,
    utilization: item.utilization === true || item.utilization === "true" ? "Yes" : "No"
  }));

  const formatFacilitiesData = (data) => {
    if (!data) return {};
    const formatYesNo = (val) => {
      if (val === true || val === "true") return "Yes";
      if (val === false || val === "false") return "No";
      return val ?? "-";
    };
    return {
      ...data,
      seperate_female_toilets: formatYesNo(data.seperate_female_toilets),
      girls_commonroom: formatYesNo(data.girls_commonroom),
      playground_tieup: formatYesNo(data.playground_tieup),
      transport_facility_avail: formatYesNo(data.transport_facility_avail),
      biometric_adopted_for_teaching_non: formatYesNo(data.biometric_adopted_for_teaching_non),
      biometric_adopted__for_students_ug_pg: formatYesNo(data.biometric_adopted__for_students_ug_pg),
    };
  };

  const formatLibraryData = (data) => {
    if (!data) return {};
    const formatYesNo = (val) => {
      if (val === true || val === "true") return "Yes";
      if (val === false || val === "false") return "No";
      return val ?? "-";
    };
    return {
      ...data,
      separate_room: formatYesNo(data.separate_room),
      high_speed: formatYesNo(data.high_speed),
      nptel: formatYesNo(data.nptel),
      digital: formatYesNo(data.digital),
      access_online_course: formatYesNo(data.access_online_course),
      repgraphic_phtgraphic: formatYesNo(data.repgraphic_phtgraphic),
      automation_software: formatYesNo(data.automation_software),
    };
  };

  const isManagement =
    (nocdata?.societyName_status &&
      societyName?.length > 0 &&
      service === "Management Change") ||
    InspStatusNocType === "management" ||
    inspNocType === "management";

  if (isManagement) {
  }
  // console.log("newCoursenewCoursenewCoursenewCourse", nocdata?.newCourse[0])
  return (
    <div className="pvp-root">
      {/* ✅ Injects print CSS once on mount, cleans up on unmount */}
      <PrintStyles />

      <div className="pvp-header" style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "12px 16px",
        borderBottom: "0.5px solid #e5e7eb",
        marginBottom: "1.5rem"
      }}>
        <button
          className="pvp-print-btn"
          onClick={() => {
            const s = document.createElement("style");
            s.id = "__pvp_noheader";
            s.innerHTML = `@page { margin: 10mm 8mm; size: A4 portrait; }`;
            document.head.appendChild(s);
            window.print();
            window.addEventListener(
              "afterprint",
              () => document.getElementById("__pvp_noheader")?.remove(),
              { once: true }
            );
          }}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
            strokeLinecap="round" strokeLinejoin="round" style={{ width: 16, height: 16 }}>
            <polyline points="6 9 6 2 18 2 18 9" />
            <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
            <rect x="6" y="14" width="12" height="8" />
          </svg>
          Print / Download Preview
        </button>
      </div>

      <div className="pvp-section">
        <SecHdr icon="🏫" title="Institute Details" color="#2563eb" bg="#eef3fe" />
        <FieldGrid data={inst} fields={INST_FIELDS} />
      </div>



      <div className="pvp-section">
        <SecHdr icon="🏫" title="Institute Society Details" color="#2563eb" bg="#eef3fe" />
        <FieldGrid data={inst} fields={INST_Society} />
      </div>



      <div className="pvp-section">
        <SecHdr icon="🏫" title="NAAC Details" color="#2563eb" bg="#eef3fe" />
        <FieldGrid data={inst} fields={INST_NACC} />
      </div>

      {courses.length > 0 && (
        <div className="pvp-section">
          <SecHdr icon="📚" title="Course Intake Details" color="#0d9e76" bg="#e6f6f2" count={courses.length} />
          <ArrayTable rows={courses} columns={COURSE_COLS} valueMaps={courseValueMaps} />
        </div>
      )}

      {(
        land.length > 0 || own.length > 0 || lease.length > 0 ||
        buildingBlocks.length > 0 || buildArea.length > 0 ||
        instructional.length > 0 || facilities.length > 0 ||
        library.length > 0 || software.length > 0 ||
        journal.length > 0 || labs.length > 0
      ) && (
          <div className="pvp-section">
            <SecHdr icon="🏢" title="Infrastructure Details" color="#1f2937" bg="#e5e7eb" />




            {(nocdata?.land?.length > 0 || nocdata?.lease?.length > 0) && (
              <div className="pvp-section">
                {/* <SecHdr icon="🏞️" title="Land  Allocation Details" color="#15803d" bg="#dcfce7" /> */}

                {land?.length > 0 && (
                  <div className="pvp-subsection">
                    <SecHdr icon="📋" title="Land Details" color="#0d9e76" bg="#e6f6f2" />
                    <FieldGrid data={formattedBasicData} fields={SOC_LAND_BASIC_FIELDS} />
                  </div>
                )}


                {land?.length > 0 && check_lease_own == true && (
                  <div className="pvp-subsection">
                    <SecHdr icon="📋" title=" Land Details (Own)" color="#0d9e76" bg="#e6f6f2" />
                    <FieldGrid data={formattedLandAllData} fields={LAND_ALL_FIELDS} />
                  </div>
                )}


                {formattedOtherColleges?.length > 0 && (
                  <div className="pvp-subsection">
                    <SecHdr icon="🏫" title="Other College Details" color="#2563eb" bg="#eef3fe" />
                    <ArrayTable rows={formattedOtherColleges} columns={OTHER_COLLEGE_COLS} />
                  </div>
                )}




                {nocdata?.own?.length > 0 && (
                  <div className="pvp-subsection">
                    <SecHdr icon="🏠" title="Registered Land Details" color="#0f766e" bg="#f0fdfa" />
                    <ArrayTable rows={nocdata.own} columns={REGISTERED_LAND_COLS} />
                  </div>
                )}

                {nocdata?.lease?.length > 0 && check_lease_own === false && (
                  <div className="pvp-subsection">
                    <SecHdr icon="📄" title="Building Lease Details Report" color="#b45309" bg="#fff7ed" />
                    <ArrayTable rows={nocdata.lease} columns={BUILDING_LEASE_COLS} />
                  </div>
                )}

                {/* {nocdata?.own?.length > 0 && (
                  <div className="pvp-subsection">
                    <SecHdr icon="🏠" title="Land Details Report" color="#0f766e" bg="#f0fdfa" />
                    <ArrayTable rows={nocdata.own} columns={REGISTERED_LAND_COLS} />
                  </div>
                )} */}
                {/* Location of Land for Shifting (when build_own_lease = false) */}
                {formattedBuildOwnLease === "Leased" && formattedShiftingData.plot_no && (
                  <div className="pvp-subsection">
                    <SecHdr icon="📍" title="Location of the Land for Shifting" color="#d96119" bg="#fdf0e8" />
                    <FieldGrid data={formattedShiftingData} fields={LOCATION_SHIFTING_FIELDS} />
                  </div>
                )}

                {/* Land Details (when build_own_lease = true) */}
                {formattedBuildOwnLease === "Own" && formattedOwnLandData.land_coll_run && (
                  <>
                    <div className="pvp-subsection">
                      <SecHdr icon="🌾" title="Land Details" color="#1a56db" bg="#ebf5ff" />
                      <FieldGrid data={formattedOwnLandData} fields={LAND_DETAILS_OWN_FIELDS} />
                    </div>

                    <div className="pvp-subsection">
                      <SecHdr icon="📅" title="Society-College Land Allotment Details" color="#c08a10" bg="#fdf6e3" />
                      <FieldGrid data={formattedAllotmentData} fields={SOC_ALLOTMENT_FIELDS} />
                    </div>

                    {/* Upload Copy of Resolution */}
                    {landData.soc_copy_upload && (
                      <div className="pvp-subsection">
                        <SecHdr icon="📎" title="Upload Copy of Resolution" color="#be185d" bg="#fdf2f8" />
                        <div className="pvp-kv-grid">
                          <div className="pvp-kv-item">
                            <span className="pvp-kv-key">Resolution Document</span>
                            <span className="pvp-kv-val">
                              <button type="button" className="btn btn-link p-0 text-primary" onClick={() => viewImage(landData.soc_copy_upload)}>
                                View Document
                              </button>
                            </span>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Khasra plan/Location Map */}
                    <div className="pvp-subsection">
                      <SecHdr icon="🗺️" title="Khasra plan/Location Map Issued by the MRO" color="#4f46e5" bg="#eef2ff" />
                      <FieldGrid data={formattedKhasraData} fields={KHASRA_PLAN_FIELDS} />

                      {/* Upload Certificate */}
                      {landData.khasra_plan_file && (
                        <div className="pvp-kv-grid mt-2">
                          <div className="pvp-kv-item">
                            <span className="pvp-kv-key">Upload Certificate</span>
                            <span className="pvp-kv-val">
                              <button type="button" className="btn btn-link p-0 text-primary" onClick={() => viewImage(landData.khasra_plan_file)}>
                                View Document
                              </button>
                            </span>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Land Conversion Details */}
                    {landData.land_conv_details === true && (
                      <div className="pvp-subsection">
                        <SecHdr icon="🔄" title="Land Conversion Details" color="#0d9e76" bg="#e6f6f2" />
                        <div className="pvp-kv-grid mb-2">
                          <div className="pvp-kv-item">
                            <span className="pvp-kv-key">Land Conversion Details are available</span>
                            <span className="pvp-kv-val">Yes</span>
                          </div>
                        </div>
                        <FieldGrid data={formattedLandConversionData} fields={LAND_CONVERSION_FIELDS} />
                        {landData.land_conversion_file && (
                          <div className="pvp-kv-grid mt-2">
                            <div className="pvp-kv-item">
                              <span className="pvp-kv-key">Upload Conversion Certificate</span>
                              <span className="pvp-kv-val">
                                <button type="button" className="btn btn-link p-0 text-primary" onClick={() => viewImage(landData.land_conversion_file)}>
                                  View Document
                                </button>
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Land Usage Details */}
                    {landData.land_usage_details === true && (
                      <div className="pvp-subsection">
                        <SecHdr icon="🏭" title="Land Usage Details" color="#b45309" bg="#fff7ed" />
                        <div className="pvp-kv-grid mb-2">
                          <div className="pvp-kv-item">
                            <span className="pvp-kv-key">Land Usage Details are available</span>
                            <span className="pvp-kv-val">Yes</span>
                          </div>
                        </div>
                        <FieldGrid data={formattedLandUsageData} fields={LAND_USAGE_FIELDS} />
                        {landData.land_usage_certificate && (
                          <div className="pvp-kv-grid mt-2">
                            <div className="pvp-kv-item">
                              <span className="pvp-kv-key">Upload Land Usage Certificate</span>
                              <span className="pvp-kv-val">
                                <button type="button" className="btn btn-link p-0 text-primary" onClick={() => viewImage(landData.land_usage_certificate)}>
                                  View Document
                                </button>
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
            )}


            {/* {lease.length > 0 && (
              <div className="pvp-subsection">
                <SecHdr icon="🤝" title="Lease Details" color="#b45309" bg="#fff7ed" />
                <ArrayTable rows={lease} columns={LEASE_COLS} />
              </div>
            )} */}

            {buildingBlocks.length > 0 && (
              <div className="pvp-subsection">
                <SecHdr icon="🏗️" title="Building Block Details" color="#d96119" bg="#fdf0e8" />
                <ArrayTable rows={buildingBlocks} columns={BUILDING_COLS} />
              </div>
            )}

            {buildArea.length > 0 && (
              <div className="pvp-subsection">
                <SecHdr icon="📐" title="Build Area Details" color="#0f766e" bg="#f0fdfa" />
                <FieldGrid data={buildArea[0]} fields={BUILD_AREA_FIELDS} />
              </div>
            )}

            {instructional.length > 0 && (
              <div className="pvp-subsection">
                <SecHdr icon="🪑" title="Instructional Area Details" color="#8b46c9" bg="#f3ebfd" />
                <ArrayTable rows={instructional} columns={INSTRUCTIONAL_COLS} />
              </div>
            )}

            {facilities.length > 0 && (
              <div className="pvp-subsection">
                <SecHdr icon="🏛️" title="College Facilities" color="#0b8fbd" bg="#e3f6fd" />
                <FieldGrid data={formatFacilitiesData(facilities[0])} fields={FACILITIES_FIELDS} />
              </div>
            )}

            {library.length > 0 && (
              <div className="pvp-subsection">
                <SecHdr icon="📖" title="Library Facilities" color="#1a56db" bg="#ebf5ff" />
                <FieldGrid data={formatLibraryData(library[0])} fields={LIBRARY_FIELDS} />
              </div>
            )}

            {software.length > 0 && (
              <div className="pvp-subsection">
                <SecHdr icon="💾" title="Software Details" color="#4f46e5" bg="#eef2ff" />
                <ArrayTable rows={software} columns={SOFTWARE_COLS} />
              </div>
            )}

            {journal.length > 0 && (
              <div className="pvp-subsection">
                <SecHdr icon="📰" title="Journal Details" color="#0d9e76" bg="#e6f6f2" />
                <ArrayTable rows={journal} columns={JOURNAL_COLS} />
              </div>
            )}

            {labs.length > 0 && (
              <div className="pvp-subsection">
                <SecHdr icon="🔬" title="Lab Details" color="#d63039" bg="#fdeaea" />
                <ArrayTable rows={formattedLabs} columns={LAB_COLS} />
              </div>
            )}
          </div>
        )}

      {staff?.length > 0 && (
        <div className="pvp-section">
          <SecHdr icon="👨‍🏫" title="Staff Details" color="#c08a10" bg="#fdf6e3" count={staff.length} />
          <ArrayTable rows={staff} columns={STAFF_COLS} />
        </div>
      )}



      {corpusData?.data?.length > 0 && (service === "Extension of Permission (EoP)" || InspStatusNocType === "eop" || inspNocType === "eop") && (
        <div className="pvp-section">
          <SecHdr
            icon="📄"
            title="UG Corpus Fund Details"
            color="#0f766e"
            bg="#ecfeff"
          />
          <FieldGrid data={corpusData} fields={CorpusBasicCols} />
        </div>
      )}
      {corpusInstall.length > 0 && (
        <div className="pvp-section">
          <SecHdr icon="🏦" title="Corpus Fund Installments" color="#be185d" bg="#fdf2f8" count={corpusInstall.length} />
          <ArrayTable rows={corpusInstall} columns={CORPUS_INSTALL_COLS} />
        </div>
      )}

      {corpusUGPG.length > 0 && (
        <div className="pvp-section">
          <SecHdr icon="🏦" title="Corpus Fund (UG/PG)" color="#be185d" bg="#fdf2f8" count={corpusUGPG.length} />
          <ArrayTable rows={corpusUGPG} columns={CORPUS_COLS} />
        </div>
      )}

      {pgCourses.length > 0 && (
        <div className="pvp-section">
          <SecHdr icon="🎓" title="PG Courses Summary" color="#4f46e5" bg="#eef2ff" count={pgCourses.length} />
          <ArrayTable rows={pgCourses} columns={UG_PG_COLS} />
        </div>
      )}


      {(
        EopApplication?.length > 0 ||
        service === "Extension of Permission (EoP)" ||
        InspStatusNocType === "eop" ||
        inspNocType === "eop"
      ) && (
          <div className="pvp-section">
            <SecHdr icon="📋" title="Application Form" color="#be185d" bg="#fdf2f8" />
            <FieldGrid data={EopApplication} fields={EopApplicationCols} />
          </div>
        )}
      {/* 
      {Shiftingser?.length > 0 && (service === "Shifting of the Institution" || InspStatusNocType === "shifting" || inspNocType === "shifting") && (

        <div className="pvp-subsection">
          <SecHdr icon="🏛️" title="ShitingApplication Form" color="#0b8fbd" bg="#e3f6fd" />
          <FieldGrid data={Shiftingser} fields={ShiftingApplicationSer} />
        </div>
      )} */}

      {Shiftingser.length > 0 &&
        (
          service === "Shifting of the Institution" ||
          InspStatusNocType === "shifting" ||
          inspNocType === "shifting" ||
          isNocUser
        ) && (
          <div className="pvp-section">
            <SecHdr
              icon="🏛️"
              title="Shifting Application Form"
              color="#0b8fbd"
              bg="#e3f6fd"
            />

            <FieldGrid
              data={Shiftingser}
              fields={ShiftingApplicationSer}
            />
          </div>
        )}

      {Clg !== "degree" && (
        <>
          {enhance.length > 0 && (
            <div className="pvp-section">
              <SecHdr icon="📈" title="Enhance / Reduction Details" color="#0b8fbd" bg="#e3f6fd" count={enhance.length} />
              <ArrayTable rows={enhance} columns={ENHANCE_COLS} />
            </div>
          )}


          {mergeClose?.length > 0 && (InspStatusNocType === "additional_sec" || inspNocType === "additional_sec") && (
            <div className="pvp-section">
              <SecHdr icon="🔀" title="Merge / Name Change / Closure (Course)" color="#7b2ff7" bg="#f3ebfd" count={mergeClose.length} />
              <ArrayTable rows={mergeClose} columns={MERGE_COLS} />
            </div>
          )}



          {/* {closure.length > 0 && (
            <div className="pvp-section">
              <SecHdr icon="🔒" title="Institution Closure Details" color="#991b1b" bg="#fef2f2" count={closure.length} />
              <ArrayTable rows={closure} columns={CLOSURE_COLS} />
            </div>
          )} */}
          {nocdata?.societyName_status && societyName.length > 0 && (service === "Management Change" || InspStatusNocType === "management" || inspNocType === "management") && (
            <div className="pvp-section">
              <SecHdr icon="🏛️" title="Society / Trust Details" color="#4f46e5" bg="#eef2ff" count={societyName.length} />
              <ArrayTable
                rows={societyName}
                columns={[
                  { key: "current_name_of_trust", label: "Handing Over Society" },
                  { key: "proposed_new_name", label: "Name of the Taken over Society" },
                  { key: "current_address", label: "Address of the Handing Over Society" },
                  { key: "new_address", label: "New Address (if changed)" },
                  { key: "reason_for_change", label: "Reason" },
                  { key: "name_address_change", label: "Change Type" },
                  // { key: "inst_name", label: "Institution Name" },
                  // { key: "ac_year", label: "AC Year" },
                ]}
              />
            </div>
          )}

          {/* {nocdata?.typeconv_status && typeconv.length > 0 && (
            <div className="pvp-section">
              <SecHdr icon="🔄" title="Type Conversion" color="#1a56db" bg="#ebf5ff" count={typeconv.length} />
              <ArrayTable rows={typeconv} columns={TYPECONV_COLS} />
            </div>
          )} */}

        </>
      )}

      {/* 
      {nocdata?.shifting_status && shifting.length > 0 && service === "Shifting of the Institution" || InspStatusNocType === "shifting" || inspNocType === "shifting" && (
        <div className="pvp-section">
          <SecHdr icon="🚚" title="Shifting / Change of Location" color="#0f766e" bg="#f0fdfa" count={shifting.length} />
          <ArrayTable rows={shifting} columns={SHIFTING_COLS} />
        </div>
      )} */}
      {nocdata?.chairPerson_status && chairPerson.length > 0 && (service === "Management Change" || InspStatusNocType === "management" || inspNocType === "management") && (
        <div className="pvp-section">
          <SecHdr icon="👤" title="Secretary Details" color="#0f766e" bg="#e6fffb" count={chairPerson.length} />
          <ArrayTable
            rows={chairPerson}
            columns={[
              { key: "name_of_chairperson", label: "Name" },
              { key: "role", label: "Role" },
              { key: "responsibilities", label: "Responsibilities" },
              { key: "contact", label: "Contact" },
              { key: "address", label: "Address" },
              { key: "remarks", label: "Remarks" },
              // { key: "ac_year", label: "AC Year" },
            ]}
          />
        </div>
      )}
      {/* {nameChange?.length > 0 && (service == "New Program" || InspStatusNocType === "new_program" || inspNocType === "new_program") && (

        // {newCourse?.length > 0 && (InspStatusNocType === "new_program" || inspNocType === "new_program") && (
        <div className="pvp-section">
          <SecHdr icon="➕" title="New Course Details" color="#15803d" bg="#dcfce7" count={newCourse.length} />
          <ArrayTable rows={newCourse} columns={NEWCOURSE_COLS} />
        </div>
      )} */}


      {nocdata?.boardOfGoverners_status && boardOfGoverners.length > 0 && (service === "Management Change" || InspStatusNocType === "management" || inspNocType === "management") && (
        <div className="pvp-section">
          <SecHdr icon="🏢" title="Members and Chairperson" color="#b45309" bg="#fff7ed" count={boardOfGoverners.length} />
          <ArrayTable
            rows={boardOfGoverners}
            columns={[
              { key: "name_of_chairperson", label: "Name" },
              { key: "role", label: "Role" },
              { key: "responsibilities", label: "Responsibilities" },
              { key: "contact", label: "Contact" },
              { key: "address", label: "Address" },
              { key: "remarks", label: "Remarks" },
            ]}
          />
        </div>
      )}
      {/* {nameChange?.length > 0 && (service == "Change of Institution Name" || InspStatusNocType === "change_of_inst_name" || inspNocType === "change_of_inst_name") && (
        <div className="pvp-section">
          <SecHdr icon="✏️" title="Institution Name Change" color="#c2410c" bg="#fff7ed" count={nameChange.length} />
          <ArrayTable rows={nameChange} columns={NAMECHANGE_COLS} />
        </div>
      )} */}

      {documents?.length > 0 && (
        <div className="pvp-section">
          <SecHdr icon="📎" title="Uploaded Documents" color="#1a1f36" bg="#f0f2f8" count={documents.length} />
          <DocumentsGrid docs={documents} />
        </div>
      )}




      {admission?.length > 0 && (service == "New Program" || service === "Additional Section" || service === "Conversion of Program" || InspStatusNocType === "Additional  Section" || inspNocType === "Additional" || InspStatusNocType === "new_program" || inspNocType === "new_program" || InspStatusNocType === "Conversion of Program" || inspNocType === "Conversion of Program") && (
        <div className="pvp-section">
          <SecHdr icon="🎓" title="Admission Details" color="#15803d" bg="#dcfce7" count={admission.length} />
          <ArrayTable rows={admission} columns={ADMISSION_COLS} />
        </div>
      )}
      {result?.length > 0 && (service == "New Program" || service === "Additional Section" || service === "Conversion of Program" || InspStatusNocType === "Additional  Section" || inspNocType === "Additional" || InspStatusNocType === "new_program" || inspNocType === "new_program" || InspStatusNocType === "Conversion of Program" || inspNocType === "Conversion of Program") && (
        <div className="pvp-section">
          <SecHdr icon="📊" title="Result Analysis" color="#15803d" bg="#dcfce7" count={result.length} />
          <ArrayTable rows={result} columns={RESULT_COLS} />
        </div>
      )}
      {nameChange?.length > 0 && (service == "New Program" || InspStatusNocType === "new_program" || inspNocType === "new_program") && (
        <div className="pvp-section">
          <SecHdr icon="➕" title="New Course Details" color="#15803d" bg="#dcfce7" count={newCourse.length} />

          <ArrayTable rows={newCourse} columns={NEWCOURSE_COLS} />
        </div>
      )}
      {mergeclose?.length > 0 && (service == "Additional Section" || InspStatusNocType === "Additional  Section" || inspNocType === "Additional") && (
        <div className="pvp-section">
          <SecHdr icon="
🆕 " title="Additional Section Details" color="#15803d" bg="#dcfce7" count={filteredData?.length} />
          <ArrayTable rows={filteredData} columns={MERGECLOSE_COLS} />
        </div>
      )}

      {mergeclose?.length > 0 && (service == "Conversion of Program" || InspStatusNocType === "Conversion of Program" || inspNocType === "Conversion of Program") && (
        <div className="pvp-section">
          <SecHdr icon="🔄 " title="Conversion of Program" color="#15803d" bg="#dcfce7" count={filteredData?.length} />
          <ArrayTable rows={filteredData} columns={CONVERSION_COLS} />
        </div>
      )}
      {/* {service === "Extension of Permission (EoP)" && (
        <>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {

              handleDownloadPDF();
            }}
          >
            📄 Download Deficiencies PDF
          </button>
        </>
      )} */}



    </div >
  );
}